// sanitizeHtml — تنقية HTML المخزَّن (مثل pedigree_html) قبل عرضه عبر dangerouslySetInnerHTML،
// منعًا لـXSS مخزَّن (وسوم <script>، معالجات on*، روابط javascript:/data:). يعتمد DOMPurify
// (المرجع الموثوق). هذا هو خطّ الدفاع الأساسيّ — يُنقّي عند العرض فيغطّي حتى البيانات المخزَّنة سلفًا.
import DOMPurify from 'dompurify';

// إعداد متحفّظ: نسمح بوسوم العرض/الجداول الشائعة في شجرة النسب فقط، ونمنع كل ما عداها.
// (DOMPurify يزيل تلقائيًّا كل معالجات الأحداث on* وروابط javascript: حتى لو كان الوسم مسموحًا.)
const CONFIG = {
  ALLOWED_TAGS: [
    'a', 'b', 'i', 'em', 'strong', 'u', 's', 'small', 'sub', 'sup', 'br', 'hr',
    'span', 'div', 'p', 'ul', 'ol', 'li',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'caption', 'colgroup', 'col',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'center', 'font',
  ],
  ALLOWED_ATTR: ['href', 'title', 'alt', 'src', 'width', 'height', 'colspan', 'rowspan', 'align', 'valign', 'class'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input'],
};

export function sanitizeHtml(dirty) {
  if (dirty == null) return '';
  try {
    return DOMPurify.sanitize(String(dirty), CONFIG);
  } catch (_) {
    return ''; // عند أي فشل لا نعرض HTML غير مُنقّى
  }
}

export default sanitizeHtml;
